import axios from 'axios';
export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const plannerApi = (token) => {
  const headers = { Authorization: `Bearer ${token}` };
  return {
    me: () => axios.get(`${API_URL}/planner/me`, { headers }).then(r => r.data),
    listTrips: () => axios.get(`${API_URL}/planner/trips`, { headers }).then(r => r.data),
    createTrip: (data) => axios.post(`${API_URL}/planner/trips`, data, { headers }).then(r => r.data),
    getTrip: (id) => axios.get(`${API_URL}/planner/trips/${id}`, { headers }).then(r => r.data),
    updateTrip: (id, data) => axios.patch(`${API_URL}/planner/trips/${id}`, data, { headers }).then(r => r.data),
    deleteTrip: (id) => axios.delete(`${API_URL}/planner/trips/${id}`, { headers }).then(r => r.data),

    addDiver: (tripId, data) => axios.post(`${API_URL}/planner/trips/${tripId}/divers`, data, { headers }).then(r => r.data),
    updateDiver: (tripId, diverId, data) => axios.patch(`${API_URL}/planner/trips/${tripId}/divers/${diverId}`, data, { headers }).then(r => r.data),
    deleteDiver: (tripId, diverId) => axios.delete(`${API_URL}/planner/trips/${tripId}/divers/${diverId}`, { headers }).then(r => r.data),

    addCrew: (tripId, data) => axios.post(`${API_URL}/planner/trips/${tripId}/crew`, data, { headers }).then(r => r.data),
    bulkImportCrew: (tripId, rows) => axios.post(`${API_URL}/planner/trips/${tripId}/crew/bulk-import`, { rows }, { headers }).then(r => r.data),
    updateCrew: (tripId, crewId, data) => axios.patch(`${API_URL}/planner/trips/${tripId}/crew/${crewId}`, data, { headers }).then(r => r.data),
    deleteCrew: (tripId, crewId) => axios.delete(`${API_URL}/planner/trips/${tripId}/crew/${crewId}`, { headers }).then(r => r.data),

    addCylinder: (tripId, data) => axios.post(`${API_URL}/planner/trips/${tripId}/cylinders`, data, { headers }).then(r => r.data),
    updateCylinder: (tripId, cylId, data) => axios.patch(`${API_URL}/planner/trips/${tripId}/cylinders/${cylId}`, data, { headers }).then(r => r.data),
    deleteCylinder: (tripId, cylId) => axios.delete(`${API_URL}/planner/trips/${tripId}/cylinders/${cylId}`, { headers }).then(r => r.data),

    addBuddyGroup: (tripId, diverIds, crewIds = []) => axios.post(`${API_URL}/planner/trips/${tripId}/buddy-groups`, { diver_ids: diverIds, crew_ids: crewIds }, { headers }).then(r => r.data),
    deleteBuddyGroup: (tripId, groupId) => axios.delete(`${API_URL}/planner/trips/${tripId}/buddy-groups/${groupId}`, { headers }).then(r => r.data),

    generatePlan: (tripId, data) => axios.post(`${API_URL}/planner/trips/${tripId}/plan`, data, { headers }).then(r => r.data),
    manualUpdatePlan: (tripId, planDate, data) => axios.put(`${API_URL}/planner/trips/${tripId}/plan/${planDate}/manual`, data, { headers }).then(r => r.data),
    updateLaunchLog: (tripId, planDate, launchIndex, log) => axios.put(`${API_URL}/planner/trips/${tripId}/plan/${planDate}/log`, { launch_index: launchIndex, log }, { headers }).then(r => r.data),
    deletePlan: (tripId, planDate) => axios.delete(`${API_URL}/planner/trips/${tripId}/plan/${planDate}`, { headers }).then(r => r.data),
    swapLaunches: (tripId, planDate, a, b) => axios.put(`${API_URL}/planner/trips/${tripId}/plan/${planDate}/swap-launches`, { launch_a: a, launch_b: b }, { headers }).then(r => r.data),
    setAttendance: (tripId, planDate, diverId, status) => axios.put(`${API_URL}/planner/trips/${tripId}/plan/${planDate}/attendance`, { diver_id: diverId, status }, { headers }).then(r => r.data),
    diveReportPdfUrl: (tripId, planDate) => `${API_URL}/planner/trips/${tripId}/plan/${planDate}/dive-report.pdf`,
    diveReportCsvUrl: (tripId, planDate) => `${API_URL}/planner/trips/${tripId}/plan/${planDate}/dive-report.csv`,
    emailDiveReport: (tripId, planDate, recipients, message) =>
      axios.post(`${API_URL}/planner/trips/${tripId}/plan/${planDate}/dive-report/email`,
        { recipients, message: message || null },
        { headers }).then(r => r.data),

    csvImportPreview: (tripId, csvUrl) => axios.post(`${API_URL}/planner/trips/${tripId}/divers/import-preview`, { csv_url: csvUrl }, { headers }).then(r => r.data),
    csvImportPreviewFile: (tripId, file) => {
      const fd = new FormData();
      fd.append('file', file);
      return axios.post(
        `${API_URL}/planner/trips/${tripId}/divers/import-preview-file`,
        fd,
        { headers: { ...headers, 'Content-Type': 'multipart/form-data' } },
      ).then(r => r.data);
    },
    csvImportConfirm: (tripId, rows) => axios.post(`${API_URL}/planner/trips/${tripId}/divers/import-confirm`, { rows }, { headers }).then(r => r.data),

    importPlanPreview: (tripId, planDate, body) =>
      axios.post(`${API_URL}/planner/trips/${tripId}/plan/${planDate}/import-preview`, body, { headers }).then(r => r.data),
    importPlanApply: (tripId, planDate, launches) =>
      axios.post(`${API_URL}/planner/trips/${tripId}/plan/${planDate}/import-apply`, { launches }, { headers }).then(r => r.data),

    sendRecapEmails: (tripId, body) => axios.post(`${API_URL}/planner/trips/${tripId}/send-recap-emails`, body || {}, { headers }).then(r => r.data),

    exportPdfUrl: (tripId, planDate) => `${API_URL}/planner/trips/${tripId}/plan/${planDate}/pdf`,
    shareLink: (token) => `${window.location.origin}/planner/share/${token}`,
    finaliseTrip: (tripId, opts) => axios.post(`${API_URL}/planner/trips/${tripId}/finalise`, opts || {}, { headers }).then(r => r.data),
    downloadDiveRecon: async (tripId, fmt, withCosts = false) => {
      const r = await axios.get(`${API_URL}/planner/trips/${tripId}/dive-recon.${fmt}${withCosts ? '?with_costs=true' : ''}`, {
        headers, responseType: 'blob',
      });
      const blob = new Blob([r.data], {
        type: fmt === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `dive-recon${withCosts ? '-with-costs' : ''}.${fmt}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },
  };
};
